<script lang="ts" setup>
import { DEFUNCT_SHIPPING_LINES } from '~/constants'
import type { ShippingLine } from '~/services/apiClient'
import { useShippingLinesStore } from '~/stores/shippingLines'

const props = withDefaults(
  defineProps<{
    modelValue: ShippingLine | undefined
    clearable?: boolean
    disabled?: boolean
  }>(),
  { clearable: false, disabled: false }
)
const emit = defineEmits<{
  (e: 'update:modelValue', value: string | undefined): void
}>()
const selectedShippingLine = useVModel(props, 'modelValue', emit)
const shippingLineStore = useShippingLinesStore()

onMounted(shippingLineStore.loadShippingLinesCached)

const lines = computed(() => {
  const lines = shippingLineStore.shipping_lines
  return lines.filter((line) => !DEFUNCT_SHIPPING_LINES.has(line.shipping_line))
})
</script>

<template>
  <el-select
    v-model="selectedShippingLine"
    :loading="shippingLineStore.loading"
    filterable
    size="large"
    :clearable="clearable"
    :disabled="disabled"
    style="min-width: 160px"
  >
    <el-option
      v-for="option in lines"
      :key="option.shipping_line"
      :label="option.long_desc"
      :value="option.shipping_line"
    />
  </el-select>
</template>
